import React from 'react';
import { FormPlaceholder } from './FormPlaceholder';
export function Hero() {
  return <section className="relative bg-cream py-12 md:py-16 px-6 md:px-12 overflow-visible" data-id="element-70">
      {/* Back layer: marina hero image */}
      <img src="https://cdn.magicpatterns.com/uploads/fzePdnrd2cfAGJ2CHQyrKK/queen_boat_co.jpg" alt="Queen Boat Co. marina on Lake George" className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-71" />
      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-72">
        <div className="max-w-2xl bg-cream/90 backdrop-blur-sm rounded-2xl shadow-lg p-8 md:p-10" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/uRbkKVm2QnsBqNb5EX25cD/Queen_co_boat_company_logo.png" alt="Queen Boat Co. — Freedom Boat Club Lake George" className="h-20 object-contain mb-6" data-id="element-74" />
          <div className="inline-block mb-4 px-3 py-1 bg-white rounded-full text-sm font-semibold text-copper border border-copper/20 shadow-sm" data-id="element-75">
            Lake George Full Service Marina
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-76">
            Pre-Owned Boats for Sale on Lake George
          </h1>
          <p className="text-lg md:text-xl text-navy-700 mb-8 leading-relaxed" data-id="element-77">
            Professionally maintained Freedom Boat Club fleet boats that are
            serviced regularly and ready for your next season on the water.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-78">
            <a href="#inventory" className="inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-colors duration-200 bg-copper text-white hover:bg-copper-600" data-id="element-79">
              View Inventory
            </a>
          </div>
        </div>

        <div className="w-full max-w-md mx-auto lg:max-w-full lg:ml-auto shadow-xl rounded-2xl bg-white" data-id="element-80">
          <FormPlaceholder data-id="element-81" />
        </div>
      </div>
    </section>;
}